import { render, staticRenderFns } from "./LEDPCB65Fluffy.vue?vue&type=template&id=5c804fd0&scoped=true&"
import script from "./LEDPCB65Fluffy.vue?vue&type=script&lang=js&"
export * from "./LEDPCB65Fluffy.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB65Fluffy.vue?vue&type=style&index=0&id=5c804fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c804fd0",
  null
  
)

export default component.exports